<div [ngClass]="{indicator:globals.indicator$ | async}"></div>

<div class="wrap">
  <router-outlet></router-outlet>
</div>